import ExpandedSection from '@components/ExpandedSection';
import { isLocationListed } from '@helpers/directories';
import { isGoogleListingConnected, isPinFollowingGoogle } from '@helpers/locations';
import { useTranslation } from '@hooks';
import IntegrationsTable from '../IntegrationsTable';
import Profiles from '../Profiles';
import GeneralInfo from './GeneralInfo';
import Contacts from './Contacts';
import SocialLinks from './SocialLinks';
import Address from './Address';
import AdditionalInfo from './AdditionalInfo';
import BusinessHours from './BusinessHours';
import SpecialHours from './SpecialHours';
import Appearance from './Appearance';
import PaymentMethods from './PaymentMethods';
import CategoriesAndServices from './CategoriesAndServices';
import LocalDirectories from './LocalDirectories';
import { Body } from './styles';
import { sectionElementId } from './sections';

const FormSections = ({
    account,
    language,
    countries,
    selectedCompany,
    setSelectedCompany,
    isInitialFormValid,
    menus,
    sectionsOpen,
    toggleSection,
}) => {
    const { t } = useTranslation();
    const countryLockHint = isGoogleListingConnected(selectedCompany)
        ? 'SettingsCompanies.countryLockedByGoogle'
        : isLocationListed(selectedCompany)
          ? 'SettingsCompanies.countryLockedByListings'
          : null;

    return (
        <Body>
            <ExpandedSection
                id={sectionElementId('general')}
                isOpen={sectionsOpen.general}
                onClick={() => toggleSection('general')}
                text={t('SettingsCompanies.generalInfo')}
            >
                <GeneralInfo locale={account?.locale} industry={account?.industry} />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('contact')}
                isOpen={sectionsOpen.contact}
                onClick={() => toggleSection('contact')}
                text={t('SettingsCompanies.contact')}
            >
                <Contacts accountLocale={account?.locale} />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('address')}
                isOpen={sectionsOpen.address}
                onClick={() => toggleSection('address')}
                text={t('SettingsCompanies.address')}
            >
                <Address
                    language={language}
                    countries={countries}
                    countryLockHint={countryLockHint}
                    pinLocked={isPinFollowingGoogle(selectedCompany)}
                />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('businessHours')}
                isOpen={sectionsOpen.businessHours}
                onClick={() => toggleSection('businessHours')}
                text={t('SettingsCompanies.businessHours')}
            >
                <BusinessHours />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('specialHours')}
                isOpen={sectionsOpen.specialHours}
                onClick={() => toggleSection('specialHours')}
                text={t('SettingsCompanies.specialHours')}
            >
                <SpecialHours />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('additionalInfo')}
                isOpen={sectionsOpen.additionalInfo}
                onClick={() => toggleSection('additionalInfo')}
                text={t('SettingsCompanies.additionalInformation')}
            >
                <AdditionalInfo industry={account?.industry} companyId={selectedCompany?.companyId} menus={menus} />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('services')}
                isOpen={sectionsOpen.services}
                onClick={() => toggleSection('services')}
                text={t('SettingsCompanies.categoriesAndServices')}
            >
                <CategoriesAndServices />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('paymentMethods')}
                isOpen={sectionsOpen.paymentMethods}
                onClick={() => toggleSection('paymentMethods')}
                text={t('common.paymentMethods')}
            >
                <PaymentMethods industry={account?.industry} />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('appearance')}
                isOpen={sectionsOpen.appearance}
                onClick={() => toggleSection('appearance')}
                text={t('common.appearance')}
            >
                <Appearance companyId={selectedCompany?.companyId} industry={account?.industry} />
            </ExpandedSection>
            <ExpandedSection
                id={sectionElementId('socialLinks')}
                isOpen={sectionsOpen.socialLinks}
                onClick={() => toggleSection('socialLinks')}
                text={t('SettingsCompanies.socialLinks')}
            >
                <SocialLinks lockedSocialPlatforms={selectedCompany?.lockedSocialPlatforms} />
            </ExpandedSection>
            <LocalDirectories
                account={account}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                isInitialFormValid={isInitialFormValid}
                isOpen={sectionsOpen.localDirectories}
                onToggle={() => toggleSection('localDirectories')}
            />
            <IntegrationsTable
                account={account}
                selectedCompany={selectedCompany}
                setSelectedCompany={setSelectedCompany}
                isInitialFormValid={isInitialFormValid}
            />
            <Profiles selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} />
        </Body>
    );
};

export default FormSections;
